import React from "react";

function Page404() {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card card-body">
            <h1>404 ページが見つかりません</h1>
            <h3>検索しているURL/ページが見つかりません</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page404;
